import React from 'react';
import { TouchableOpacity, View ,Dimensions } from 'react-native';
import { Text } from 'react-native-paper';
import { SliderBox } from "react-native-image-slider-box";


export default class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      images: [
        require('../assets/ob/ob1.png'),
        require('../assets/ob/ob2.png'),
        require('../assets/ob/ob3.png'),
      ]
    };
  }

  render() {
    return (
    <View style={{height:'100%'}}>

         <SliderBox  resizeMode={'contain'} sliderBoxHeight={Dimensions.get('window').height-60} images={this.state.images} />
        

          <TouchableOpacity activeOpacity={0.7} style={{height: 60, backgroundColor:'#2ebbc4', elevation: 15}} onPress={() => this.props.navigation.navigate('Login')}>
              <Text style={{marginBottom:'auto',marginTop:'auto',marginLeft:'auto',marginRight:'auto',color:'white',fontSize:18}} >ثبت نام / ورود</Text>
            </TouchableOpacity>

    </View>
    );
  }
}

